module.exports = "<div style=\"height: calc(100% - 40px - 71.6px)\">\n    <div class=\"row text-center\">\n        <span>You can download your PDF from following link</span>\n    </div>\n    <div class=\"row text-center\">\n        <a href=\"{{fileUrl}}\">Download</a>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/content/ebook/ebook.component.html
// module id = 857
// module chunks = 0